import React, { createContext, useState } from 'react';

// Create the context
const DataContext = createContext();

// Create a provider component
const DataProvider = ({ children }) => {

    const init = {
        "token": null,
        "tokenData": null,
        "mobileNumber": null,
        "couponCode": null,
        "userType": null,
        "eventId": null,
        "registration": null,
        "couponShow": null,
        "couponCheck": null,
        "couponCheckCode": null,
        "couponCheckMsg": null,
        "transactionStatus": null,
        "scanVal": null,
        "userDetailsBankMsg": null,
        "userDetailsUpiMsg": null
    }
    const [data, setData] = useState(init);



    return (
        <DataContext.Provider value={{ data, setData }}>
            {children}
        </DataContext.Provider>
    );
}

export { DataContext, DataProvider };